<template>
  <modal
    name="sbp-payment"
    width="100%"
    height="auto"
    :scrollable="true"
    :clickToClose="false"
    @opened="openDialogHandler"
  >
    <h1 class="modal-label">Оплата с помощью Системы быстрых платежей</h1>

    <div class="sbp-content">
      <div>
        <qrcode :value="url" :options="{ size: 160 }"></qrcode>
      </div>
      <div>
        <p>
          Для оплаты отсканируйте QR-код в приложении банка со своего мобильного
          телефона.
        </p>
        <p>После успешной оплаты страница автоматически обновится.</p>
        <p v-if="this.theatre.SessionDuration">
          Заказ необходимо оплатить в течение
          {{ this.theatre.SessionDuration }} минут, по истечении времени заказ
          будет отменен.
        </p>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SbpPayment',

  props: ['url', 'paymentId'],

  watch: {
    orderInfo(val) {
      if (val) {
        this.$router.push({ name: 'success' });
      }
    },
  },

  computed: {
    ...mapState(['theatre', 'orderInfo']),
  },
  methods: {
    hide() {
      this.$modal.hide('sbp-payment');
    },
    openDialogHandler() {
      this.$store.dispatch('checkPaymentAndSetOrderInfo', {
        paymentId: this.paymentId,
      });
    },
  },
};
</script>

<style lang="scss">
.sbp-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}

.v--modal {
  background-color: #000000d5 !important;
  display: block;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  &-overlay[data-modal='spb-payment'] {
    overflow-x: hidden;
    .b-text {
      margin-bottom: 15px;
      p {
        margin-bottom: 8px;
      }
      strong {
        font-weight: bold;
      }
      a {
        color: #0d76ff;
      }
    }
    .modal-button {
      padding: 0 30px;
    }
    .v--modal-box {
      padding: 20px 30px;
    }
    .pz-close-btn {
      top: 0;
      right: -10px;
    }
    .modal-label {
      padding: 0 70px 10px;
      margin-top: 20px;
    }
  }
}

.modal {
  &-form {
    width: 335px;
  }
  &-label {
    display: block;
    padding: 0 10px 10px;
    font-size: 24px;
    margin-bottom: 20px;
    line-height: 24px;
    letter-spacing: 0.024em;
    color: #fff;
    text-align: center;
  }
  &-input {
    margin-bottom: 15px;
    input {
      border: none;
      outline: none;
      background-color: #fff;
      border-radius: 10px;
      padding: 16px 25px;
      font-size: 18px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 100%;
    }
  }
  &-buttons {
    display: flex;
    flex-wrap: nowrap;
  }
  &-button {
    margin: 0 15px 0 0;
    height: 56px;
    border-radius: 10px;
    border: 1px solid #fff;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #fff;
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 10px;
    text-align: center;
    justify-content: center;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    flex: 1;
    &:last-of-type {
      margin-right: 0;
    }
    &-primary {
      background-color: #0d76ff;
      border-color: transparent;
    }
  }
}

@media screen and (max-width: 768px) {
  .v--modal {
    &-overlay[data-modal='spb-payment'] {
      .pz-close-btn {
        top: 10px;
        right: 10px;
      }
      .modal-label {
        margin-top: 30px;
      }
    }
  }
}
</style>
